import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { FormulaList } from './FormulaList';
import './Formula.scss';
import { FormulaContainer } from './FormulaContainer/FormulaContainer';
import { Formula } from './Formula/Formula';
import stores from 'cd-eft/models/Stores';

// Taken from app.tsx to change the tab title from Formula to the formula title.
const Page = (props) => {
  React.useEffect(() => {
    if (props.title === 'Formulas')
      document.title = 'NRCS-NETS Formulas';
  }, [props.title]);
  return props.children;
};

const FormulaHomeComponent = () => {
  const { path } = useRouteMatch();
  return (
    <Fragment>
      <Switch>
        {formulaListNamesSet1.map((page) => (
          <Route key={`page-${page.path}`} exact path={`${path}/${page.path}`}>
            <Page title={page.name}>
              <FormulaContainer title={page.name} id={page.id} section={page.section} />
            </Page>
          </Route>
        ))}
        {stores.AppStore.userProfileStore.applicationFlags.enableformulas1 ? formulaListNamesSet2.map((page) => (
          <Route key={`page-${page.path}`} exact path={`${path}/${page.path}`}>
          <Page title={page.name}>
            <FormulaContainer title={page.name} id={page.id} section={page.section} />
          </Page>
        </Route>
        )) : null}

        <Route exact path={`/analysis/hydraulic-formula/:formulaId`}>
          <Formula />
        </Route>

        <Route exact path={`/analysis/hydraulic-formula`}>
          <Page title="Formulas">
            <FormulaList />
          </Page>
        </Route>
      </Switch>
    </Fragment>
  );
};

export const FormulaHome = observer(FormulaHomeComponent);

/**
 * Array of Formula pages and their paths.
 * Used in the routing above to map build the route components.
 */
const formulaListNamesSet1 = [
  { name: 'Trapezoidal Channel', path: 'trapezoidal-channel', id: 10, section: 'Hydraulic Structures' },
  { name: 'Box Inlet Drop', path: 'box-drop-inlet', id: 1, section: 'Hydraulic Structures' },
  { name: 'Hooded Inlet', path: 'hooded-inlet', id: 3, section: 'Hydraulic Structures' },
  { name: 'Pipe Drop', path: 'pipe-drop', id: 5, section: 'Hydraulic Structures' },
  { name: 'Plunge Pool', path: 'plunge-pool', id: 6, section: 'Hydraulic Structures' },
  // { name: 'Rectangular Riser Drop', path: 'rectangular-riser-drop', id: 8, section: 'Hydraulic Structures' }, // Carlos 5197,5760
  // { name: 'Parabolic Channel', path: 'parabolic-channel', id: 4, section: 'Hydraulic Structures' }, // Natalia 5670,5192
  { name: 'Straight Drop Inlet', path: 'straight-drop-inlet', id: 9, section: 'Hydraulic Structures' },
  { name: 'Water Control', path: 'water-control', id: 11, section: 'Hydraulic Structures' },
  { name: 'Dry Hydrant', path: 'dry-hydrant', id: 2, section: 'Hydraulic Structures' },
  // { name: 'Circular Section', path: 'circular-section', id: 12, section: 'Miscellaneous Hydraulic' }, // Carlos 2273,5678,5174
  // { name: 'Orifice Flow', path: 'orifice-flow', id: 13, section: 'Miscellaneous Hydraulic' }, // Kath 5613,5558
  { name: 'Pressure Flow in Pipe', path: 'pressure-flow-in-pipe', id: 14, section: 'Miscellaneous Hydraulic' },
  // { name: 'Pipe Flow Formula', path: 'pipe-flow-formula', id: 0, section: 'Miscellaneous Hydraulic' },
  { name: 'Weir Flow', path: 'weir-flow', id: 16, section: 'Weir Flow' },
  // { name: 'V-Notch Weir', path: 'vnotch-weir', id: 0, section: 'Weir Flow' },
];
export const formulaListNamesSet2 = [
  { name: 'Equilateral Triangle', path: 'equilateral-triangle', id: 18, section: 'Plane Form' },
//   { name: 'Oblique Triangle', path: 'oblique-triangle', id: 0, section: 'Plane Forms' },
//   { name: 'Parabola', path: 'parabola', id: 0, section: 'Plane Forms' },
//   { name: 'Parallelogram', path: 'parallelogram', id: 0, section: 'Plane Forms' },
  { name: 'Rectangular', path: 'rectangular', id: 22, section: 'Plane Form' },
//   { name: 'Circle', path: 'circle', id: 0, section: 'Plane Forms' },
  { name: 'Oblique_Triangle', path: 'oblique-triangle', id: 19, section: 'Plane Form' },
  //   { name: 'Parabola', path: 'parabola', id: 0, section: 'Plane Forms' },
  //   { name: 'Parallelogram', path: 'parallelogram', id: 0, section: 'Plane Forms' },
  //   { name: 'Rectangular', path: 'rectangular', id: 0, section: 'Plane Forms' },
  //   { name: 'Circle', path: 'circle', id: 0, section: 'Plane Forms' },
  { name: 'Cube', path: 'cube', id: 23, section: 'Solid Forms' },
//   { name: 'Frustrum of a Cone', path: 'frustrum-cone', id: 0, section: 'Solid Forms' },
//   { name: 'Frustrum of a Pyramid', path: 'frustrum-pyramid', id: 0, section: 'Solid Forms' },
//   { name: 'Prismatoid', path: 'prismatoid', id: 0, section: 'Solid Forms' },
//   { name: 'Rectangular Parallelepiped', path: 'rectangular-parallelepiped', id: 0, section: 'Solid Forms' },
//   { name: 'Sphere', path: 'sphere', id: 0, section: 'Solid Forms' },
  { name: 'Pump Drainage', path: 'pump-drainage', id: 7, section: 'Drainage' },
  { name: 'Subsurface Drainage', path: 'subsurface-drainage', id: 29, section: 'Drainage' },
  { name: 'Surface Inlet', path: 'surface-inlet', id: 30, section: 'Drainage' },
];
